module.exports = __webpack_public_path__ + "static/media/swipe_hand_icon.bd3616d7.gif";